<template>
  <v-row>
    <v-col cols="12" class="d-flex">
      <v-dialog v-model="dialog" persistent max-width="688">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="info" dark v-bind="attrs" v-on="on" small>
            Filter
          </v-btn>

          <div class="subtitle-2 d-flex" style="color:#FFA726;">
            <v-btn
              color="error"
              small
              class="ml-3"
              dark
              v-show="showReset"
              @click="() => {
                $emit('childResetFilter');
                // resetFilter();
              }"
            >
              <v-icon small>fas fa-sync-alt</v-icon>
            </v-btn>
            <div class="ml-3 mt-1">{{ showLabel }}</div>
          </div>
        </template>
        <v-card>
          <v-card-title class="headline">Filter By Month</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="4" v-if="myFilters == 'with_filter'">
                <v-autocomplete
                  v-model="maxItem"
                  ref="maxItem"
                  auto-select-first
                  :items="maxItems"
                  item-text="name"
                  item-value="value"
                  label="Show Data"
                  >
                </v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="myFilters == 'with_filter'">
                <v-autocomplete
                  v-model="sort"
                  ref="sort"
                  auto-select-first
                  :items="sortItems"
                  item-text="name"
                  item-value="value"
                  label="Sort By"
                  >
                </v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="myFilters == 'with_filter'">
                <v-autocomplete
                  v-model="region"
                  ref="region"
                  :items="getRegionData"
                  label="Region"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-date-picker
                  v-model="dates"
                  ref="dates"
                  range
                  full-width
                  type="month"
                  no-title
                  flat
                  class="my-6"
									:max="todayDate"
                  :show-current="false"
                ></v-date-picker>
              </v-col>
              <v-col class="d-flex" cols="12">
                <v-btn
                  class="ml-auto"
                  color="error"
                  @click="
                    () => {
                      dialog = false;
                    }
                  "
                  small
                  >Cancel</v-btn
                >
                <v-btn
                  class="ml-4"
                  color="primary"
                  @click="
                    () => {
                      $emit('childFilterGraph', {dates, maxItem, region, sort});
                      dialog = false;
                    }
                  "
                  small
                  >Confirm</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    childFilterGraph: Function,
    setMaxGraph: Function,
    childResetFilter: Function,
    dateLabel: Array,
    myFilters: String,
    data: Object,
  },

  data() {
    return {
      dialog: false,
      dates: this._props.data.dates,
      maxItem: this._props.data.maxItem || 0,
      region: this._props.data.region || '',
      sort: this._props.data.sort || '',
      showReset: false,
			todayDate: new Date().toISOString().slice(0,10),
      maxItems: [
        {
          name: 'Top 20',
          value: 20
        }, {
          name: 'Top 50',
          value: 50
        }
      ],
      sortItems: [
        {
          name: 'Descending by login times',
          value: 'times desc'
        }, {
          name: 'Ascending by login times',
          value: 'times asc'
        }
      ],
    };
  },
  watch: {
    dialog(val) {
      if(val) this.dates = this._props.data.dates;
    },
    data(val) {
      this.dates = val.dates
      this.maxItem = val.maxItem || 20
      this.region = val.region || 'All Regions'
      this.sort = val.sort || 'times desc'
      if( 
        this.dates.length === 2 ||
        this.maxItem != 20 ||
        this.region != 'All Regions' ||
        this.sort != 'times desc'
      ) {
        this.showReset = true
      } else {
        this.showReset = false
      };
    }
  },

  computed: {
    ...mapGetters("Clientreport", ["getRegionData"]),
    showLabel() {
      let res = ""
      if(this._props.myFilters == 'with_filter') {
        res += `Filtered data Top ${this._props.data.maxItem}`
        if( this._props.data.region != 'All Regions' ) 
          res += ` of ${this._props.data.region} region`
        if (this.dateLabel.length === 2) {
          let start_date = this.dateLabel[0];
          let end_date = this.dateLabel[1];
          res += ` from ${start_date} to ${end_date}`;
        }
        let sort = this._props.data.sort.split(' ');
        let sort_by = sort[1] == 'desc' ? 'sort descending by login times' : 'sort ascending by login times';
        res += ` ${sort_by}`;
      }else{
        if (this.dateLabel.length === 2) {
          let start_date = this.dateLabel[0];
          let end_date = this.dateLabel[1];
          res = `Filtered data from ${start_date} to ${end_date}`;
        }
      }
      return res;
    }
    
  },
  created() {
    this.$store.dispatch("Clientreport/getRegionData");
  }
};
</script>
